if (!window.__submitBackInStockToKlaviyo) {
  const backInStockEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const submitBackInStockToKlaviyo = async function (event, button) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }

    const trigger = button || (event && event.currentTarget);
    const form = trigger && trigger.closest("form");
    const container = trigger && trigger.closest("back-in-stock-signup");

    if (!form || !container) {
      return false;
    }

    const emailInput = form.querySelector('input[name="email"]');
    const variantIdInput = form.querySelector('input[name="variant_id"]');
    const consentInput = container.querySelector("[data-checkbox-input]");
    const successMessage = form.querySelector(
      "[data-notify-me-success], [data-bluecore-notify-me-success]"
    );
    const errorMessage = form.querySelector(
      "[data-notify-me-error], [data-bluecore-notify-me-error]"
    );
    const defaultErrorMessage = errorMessage?.textContent || "An error occurred. Please try again.";
    const email = emailInput?.value.trim() || "";
    const variantId = variantIdInput?.value || "";
    const klaviyoKey = (container.getAttribute("data-klaviyo-key") || "").trim();

    const clearMessages = () => {
      successMessage?.classList.remove("active");
      errorMessage?.classList.remove("active");
      if (errorMessage) errorMessage.textContent = defaultErrorMessage;
    };

    const showError = (msg = defaultErrorMessage) => {
      successMessage?.classList.remove("active");
      if (errorMessage) {
        errorMessage.textContent = msg;
        errorMessage.classList.add("active");
      }
    };

    clearMessages();

    if (!email || !backInStockEmailRegex.test(email)) {
      showError("Please enter a valid email address.");
      return false;
    }

    if (consentInput?.required && !consentInput.checked) {
      showError();
      return false;
    }

    if (!klaviyoKey) {
      showError("Klaviyo API key is not configured.");
      return false;
    }

    trigger.disabled = true;

    try {
      if (!variantId) {
        throw new Error("Variant ID is not configured.");
      }

      const payload = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            channels: ["EMAIL"],
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: "$shopify:::$default:::" + variantId
              }
            }
          }
        }
      };

      const response = await fetch(
        "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" +
          encodeURIComponent(klaviyoKey),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2026-04-15"
          },
          body: JSON.stringify(payload)
        }
      );

      if (!response.ok) {
        throw new Error((await response.text()) || "HTTP " + response.status);
      }

      form.reset();
      successMessage?.classList.add("active");
      form.dispatchEvent(new CustomEvent("notify-me:success", { bubbles: true }));
    } catch (error) {
      showError(error instanceof Error ? error.message : defaultErrorMessage);
    } finally {
      trigger.disabled = false;
    }

    return false;
  };

  window.__submitBackInStockToKlaviyo = submitBackInStockToKlaviyo;
}
